import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';
import ABCyaLib from '@abcya/abcya_lib';

export default class Keyboard extends AContainer {
  constructor(scene) {
    super(scene);

    this.spacer = 2;
    this.rowSpacer = 0;
    this.allRows = [];
    this.allKeys = [];

    this.bg = this.create(0, 0, "keyboardBckg");

    if (ABCyaLib.Environment.instance.locale === 'es-US') {
      this.createRow(["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "del"]);
      this.createRow(["a", "s", "d", "f", "g", "h", "j", "k", "l", "ñ", "ü"]);
      this.createRow(["z", "x", "c", "v", "b", "n", "m", "á", "é", "í", "ó", "ú"]);
    } else {
      this.createRow(["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "del"]);
      this.createRow(["a", "s", "d", "f", "g", "h", "j", "k", "l"]);
      this.createRow(["z", "x", "c", "v", "b", "n", "m"]);
    }
  }

  createRow(keys) {
    let row = [];
    let rowWidth = 0;

    for (let n = 0; n < keys.length; n++) {
      //create an object that houses all relevant button information
      let keyObj = { obj: null, width: 0, height: 0 };

      if (keys[n] === "del") {
        let key = this.create(0, 0, "delBtn");
        key.name = "del";

        keyObj.obj = key;
        keyObj.width = key.width;
        keyObj.height = key.height;
      } else {
        const cont = this.scene.add.container(0, 0);

        let key = this.scene.addImage(0, 0, "keyBtn", this.scene.defaultAtlas, cont);
        key.name = keys[n];

        let shadow = ABCyaPhaser.Text.addText(0, 0, 32, 0x222222, FontKeys._Tertre_Med, keys[n], cont).setResolution(1.5).setOrigin(0);
        let txt = ABCyaPhaser.Text.addText(0, 0, 32, 0xdd9e13, FontKeys._Tertre_Med, keys[n], cont).setResolution(1.5).setOrigin(0);
        shadow.setPosition(key.width / 2 - txt.width / 2 + 1, -txt.height / 2 - 2);
        txt.setPosition(key.width / 2 - txt.width / 2, -txt.height / 2 - 3);

        this.add(cont);

        keyObj.obj = cont;
        keyObj.width = key.width;
        keyObj.height = key.height;
      }

      this.allKeys.push(keyObj);
      row.push(keyObj);

      rowWidth += keyObj.width + this.spacer;
    }

    //push each row array into allRows array
    this.allRows.push(row);
    this.positionRow(row, rowWidth);
  }

  positionRow(row, rowWidth) {
    //calculate the starting position based on the row's width
    let rowStart = -(rowWidth / 2);

    for (let n = 0; n < row.length; n++) {
      //set the X positions for each button
      let newX;
      if (n === 0) {
        newX = rowStart;
      } else {
        newX = row[n - 1].obj.x + row[n - 1].width + this.spacer;
      }

      //set the Y positions for each button based on the previous row
      let newY;
      if (this.allRows.indexOf(row) === 0) {
        newY = -this.bg.height / 4 - 10;
      }
      else {
        newY = this.allRows[this.allRows.indexOf(row) - 1][0].obj.y + row[n].height + this.rowSpacer + this.spacer;
      }

      row[n].obj.x = newX;
      row[n].obj.y = newY;
    }
  }

  tweenInPortal() {
    this.scene.addTween(this, 2000, { y: 768 - this.bg.height / 2 + 30 }, Phaser.Math.Easing.Quadratic.Out,
      () => { if (!gameData.gamePaused) this.enableKeys(); });
  }

  tweenOutPortal() {
    this.disableKeys();

    this.scene.addTween(this, 1000, { y: 768 + this.bg.height / 2 }, Phaser.Math.Easing.Quadratic.In);
  }

  enableKeys() {
    // there are some edge cases where this can be called without disableKeys being called
    // so make sure the pointerup listener is cleared before adding it again
    this.scene.input.off('pointerup');
    this.scene.input.on('pointerup', (pointer, obj) => { this.scene.checkClick(obj); });

    for (let n = 0; n < this.allKeys.length; n++) {
      if (this.allKeys[n].obj.length) {
        this.allKeys[n].obj.list[0].setInteractive();
      } else {
        this.allKeys[n].obj.setInteractive();
      }
    }
  }

  disableKeys() {
    this.scene.input.off('pointerup');

    for (let n = 0; n < this.allKeys.length; n++) {
      if (this.allKeys[n].obj.length) {
        this.allKeys[n].obj.list[0].disableInteractive();
      } else {
        this.allKeys[n].obj.disableInteractive();
      }
    }
  }

  cleanUp() {
    this.bg.destroy();

    for (let n = 0; n < this.allKeys.length; n++) {
      this.allKeys[n].obj.destroy();
    }

    this.allRows = [];
    this.allKeys = [];
  }
}